<template>
    <div
        v-bind:class="{ wrapper: loading, 'normal-size': loading && !small }"
        v-bind:data-test-loading="loading ? 'loading' : null">
        <slot />
        <div
            v-bind:data-no-bg="noBg || null"
            class="d-flex d-print-block justify-content-center align-items-center loader">
            <div
                v-if="small && loading"
                class="spinner" />
            <div
                v-else-if="loading"
                v-bind:style="{
                    color: textColor
                }"
                class="d-flex d-print-block p-2 message">
                <div class="me-2 spinner" />
                <div class="pt-1">
                    <slot name="loadingMessage">
                        {{ displayMessage }}
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/pcComponentDefaults.i18n";
    import { chooseHigherContrastColorAgainstBackground, getCssPropertyValue } from "ProgramAdmin/Themes/colorUtils";

    export default {
        props: {
            loading: { type: Boolean, required: false, default: false },
            message: { type: String, required: false, default: null },
            small: { type: Boolean, required: false, default: false },
            noBg: { type: Boolean, required: false, default: false }
        },
        data: function () {
            return {
                // Initially set this to black, to be updated when the component is mounted
                textColor: "#000000"
            };
        },
        computed: {
            displayMessage() {
                return this.message || this.pcLoaderLoadingMessage;
            },
            ...mapI18n({ pcLoaderLoadingMessage: KEYS.pcLoaderLoadingMessage }, NAMESPACE)
        },
        mounted() {
            this.textColor = chooseHigherContrastColorAgainstBackground(
                getCssPropertyValue("--bs-secondary") || "#e4e4e4"
            );
        }
    };
</script>

<style lang="scss" scoped>
    .normal-size {
        min-height: 4rem;
    }
    .wrapper {
        position: relative;

        > .loader {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            cursor: wait;
            z-index: 999;
            margin: 0;
            padding: 0;
        }
        .loader:before {
            background-color: black;
            opacity: 0.5;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            content: "";
            z-index: -1;
        }
        .loader[data-no-bg]:before {
            background-color: transparent;
        }
        .message {
            background-color: var(--bs-secondary);
            opacity: 1;
        }

        $borderSize: 5px;

        .spinner {
            border: $borderSize solid var(--bs-primary);
            border-top: $borderSize solid var(--bs-secondary);
            border-radius: 50%;
            width: 2rem;
            height: 2rem;
            animation: spin 2s linear infinite;
        }
    }
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
